export default __webpack_public_path__ + "static/media/instagram.e3f12e88.svg";